export default class HeaderUtils {
static generateHeaders = (headersList: any[], headerObj: any) => {
    headersList && headersList.map((headerInfo: any)=>{
        if(headerObj[headerInfo.label]){
            headerInfo.value = headerObj[headerInfo.label]
        }    
    });
    return headersList;
}
}